import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import cx from 'classnames';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import { getISOWeek, getYear, format } from 'date-fns';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import AddAlert from '@material-ui/icons/AddAlert';
import Email from '@material-ui/icons/Email';
import LockOutlined from '@material-ui/icons/LockOutlined';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import Checkbox from '@material-ui/core/Checkbox';

// core components
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import IconCard from 'components/Cards/IconCard';
import CustomInput from 'components/CustomInput/CustomInput';
import CustomPasswordInput from '../../components/CustomInput/CustomPasswordInput';
import WeekPicker from 'components/CustomInput/WeekPicker';
import CustomAutoComplete from 'components/CustomInput/CustomAutoComplete';
import ImageUpload from 'components/CustomUpload/ImageUpload';
import SearchBar from 'components/SearchBar/SearchBar';
import CustomSelectWithId from 'components/CustomInput/CustomSelectWithId';
import Snackbar from 'components/Snackbar/Snackbar';
import SweetModal from 'components/SweetModal/SweetModal';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';

// styles
import detailsPageStyle from 'views/Common/style/detailsPageStyle';

// others
import { Context } from 'context/Context';
import { transformPhone } from 'helpers/helpers';
import FormHOC from 'hoc/FormHOC';
import config from 'config';
import { tutoStudentDiary } from 'data';

class StudentRegisterRep extends React.Component {
  state = {
    associations: [],
    isModalDiaryOpen: false,
    isModalCheckDateOpen: false,
    isModalOpenUserExistOpen: false,
    collegeSelected: {},
    collegeName: '',
    dateSelectected: '',
    provider: '',
  };

  componentDidMount() {
    // College non transmis par l'étape précédente
    if (!this.props.location.state || !this.props.location.state.college) return this.props.history.push('/auth');

    // Pré-remplissage du collège
    const college = this.props.location.state.college;
    this.setState({ collegeName: college.name });
    this.setState({ collegeSelected: college.infos }, () => this.checkDateCollege());

    this.fetchClasses(college.infos.shortid);
    this.fetchAssociations();

    if (this.props.location.state) {
      this.props.location.state.email !== undefined &&
        this.props.handleOnChange(this.props.location.state.email, 'email', 'email');
      this.props.location.state.first_name !== undefined &&
        this.props.handleOnChange(this.props.location.state.first_name, 'firstName', 'text', 3);
      this.props.location.state.last_name !== undefined &&
        this.props.handleOnChange(this.props.location.state.last_name, 'lastName', 'text', 3);
    }
  }

  componentWillUnmount() {
    this.props.context.closeSnackbar();
  }
  fetchAssociations = () => {
    axios
      .get(`${config.API_URL}/public/associations/modified`)
      .then((response) => {
        this.setState({ associations: response.data });
      })
      .catch(() => {
        this.props.context.handleSnackbar({
          status: 'danger',
          message: 'Problème serveur pour obtenir les associations !',
        });
      });
  };

  fetchClasses = (shortid) => {
    const body = { shortid };
    axios
      .post(`${config.API_URL}/public/classes`, body)
      .then((response) => {
        this.setState({ classes: [...response.data, { id: 'noClass', name: 'Je ne trouve pas ma classe' }] });
      })
      .catch(() => {
        this.props.context.handleSnackbar({
          status: 'danger',
          message: 'Problème serveur pour obtenir les classes !',
        });
      });
  };

  setProviderInfos = (response, provider) => {
    if (response.error === 'popup_closed_by_user') {
      return false;
    }
    const { handleOnChange } = this.props;
    axios
      .post(`${config.API_URL}/public/auth/log_in_${provider}`, {
        access_token: response && response.accessToken,
        email: this.props.email,
        password: this.props.password,
      })
      .then(async (res) => {
        // Utilisateur existant
        if (res.status === 200) {
          this.props.context.handleSnackbar({
            status: 'danger',
            message: "L'utilisateur existe déjà",
          });
        }
        // Nouvel utilisateur
        if (res.status === 202) {
          handleOnChange(res.data.user.first_name, 'firstName', 'length', 3);
          handleOnChange(res.data.user.last_name, 'lastName', 'length', 3);
          handleOnChange(res.data.user.email, 'email', 'email');
          this.setState({
            provider: `_${provider}`,
            access_token: response.accessToken,
          });
        }
      })
      .catch(() => {
        this.props.context.handleSnackbar({
          status: 'danger',
          message: "Problème de connexion. Veuillez réessayer et vérifier que vous n'êtes pas déjà inscrit.",
        });
      });
  };

  signUp = () => {
    // Cas AUCUNE donnée venant des étapes antérieures
    if (!this.props.location.state) return this.props.history.push('/auth');

    // Cas données INCOMPLÈTES venant des étapes antérieures
    const { source } = this.props.location.state;
    const { provider, access_token } = this.state;

    const {
      email,
      password,
      firstName: first_name,
      lastName: last_name,
      address,
      phoneParent,
      longitude,
      latitude,
      department,
      association,
      startDate,
      endDate,
      diary: diary_picture,
      picture,
      curriculum,
      handleOnSubmit,
      handleOnChange,
      context,
    } = this.props;

    const validations = [
      'email',
      'password',
      'confirmPassword',
      'firstName',
      'lastName',
      'phone',
      'phoneParent',
      'address',
      'date',
      'diary',
      'checkboxCgu',
    ];

    // Validations
    if (this.props.confirmPassword !== this.props.password) {
      handleOnChange(this.props.confirmPassword, 'password', 'equalTo');
      return null;
    }
    if (!handleOnSubmit(validations)) return null;

    const phone = transformPhone(this.props.phone);
    const phone_parent = transformPhone(phoneParent);

    if (phone === phone_parent)
      return context.handleSnackbar({
        status: 'danger',
        message: 'Les deux numéros de téléphone ne doivent pas être identiques',
      });

    const body = {
      access_token,
      email,
      password,
      type: 'student',
      first_name,
      last_name,
      phone,
      phone_parent,
      address,
      loc: [longitude, latitude],
      department: department,
      internship_period: [startDate, endDate],
      college: this.state.collegeSelected,
      ...(this.props.class && { class: this.props.class }),
      picture,
      diary_picture,
      curriculum,
      association,
      source,
    };

    axios
      .post(`${config.API_URL}/public/auth/sign_up${provider}`, body)
      .then(async (res) => {
        context.updateUser(res.data.user);
        localStorage.setItem('token', JSON.stringify(res.data.user.token));
        const { is_active } = res.data.user.account;
        let finalUrl = is_active ? '/' : '/auth/bienvenue';
        return this.props.history.push(finalUrl);
      })
      .catch((errorMessage) => {
        if (!errorMessage.response.data.isUserExist) {
          this.props.context.handleSnackbar({
            status: 'danger',
            message: 'Un utilisateur exste déjà avec cet email!',
          });
        }
        errorMessage.response.data.isUserExist > 0 && this.toggleModalUserExist();
      });
  };

  checkDateCollege = () => {
    let checkDate = false;
    if (this.state.collegeSelected && this.state.collegeSelected.internship_period) {
      // eslint-disable-next-line array-callback-return
      this.state.collegeSelected.internship_period.map((period) => {
        if (this.state.dateSelectected) {
          let periodStartCollege = `${getYear(new Date(period.start))}-${getISOWeek(new Date(period.start))}`;
          let periodStageStudent = `${getYear(this.state.dateSelectected.startDate)}-${getISOWeek(
            this.state.dateSelectected.startDate,
          )}`;
          if (periodStartCollege === periodStageStudent) checkDate = true;
        }
      });
    }

    if (
      !checkDate &&
      this.state.collegeSelected &&
      this.state.collegeSelected.internship_period &&
      this.state.collegeSelected.internship_period.length > 0 &&
      this.state.dateSelectected
    )
      this.toggleModalCheckDate();
  };

  toggleModalDiary = () => {
    this.setState((prevState) => ({
      isModalDiaryOpen: !prevState.isModalDiaryOpen,
    }));
  };

  toggleModalUserExist = () => {
    this.setState((prevState) => ({
      isModalOpenUserExistOpen: !prevState.isModalOpenUserExistOpen,
    }));
  };

  toggleModalCheckDate = () => {
    this.setState((prevState) => ({
      isModalCheckDateOpen: !prevState.isModalCheckDateOpen,
    }));
  };

  render() {
    const {
      classes,
      email,
      emailState,
      passwordState,
      confirmPasswordState,
      checkboxCguState,
      checkboxCgu,
      // inputs
      firstName,
      firstNameState,
      lastName,
      lastNameState,
      phoneState,
      phoneParentState,
      addressState,
      associationAutoComplete,
      associationState,
      classState,
      // upload
      diaryLoading,
      diaryState,
      curriculumLoading,
      curriculumState,
      // date
      startDate,
      endDate,
      dateState,
      // function
      handleOnChange,
      handleOnSelect,
      handleChangeImage,
      handleChangeFile,
      handleRemoveImage,
      handleRemoveFile,
      handleChangeAddress,
      handleSelectAddress,
    } = this.props;
    const {
      closeSnackbar,
      state: { snackbar },
    } = this.props.context;

    const hasClasses = this.state.classes && this.state.classes.length > 0 && this.state.classes[0].id !== 'noClass';

    const borderButtonCurriculum = cx({
      [classes.borderButton]: !curriculumLoading,
      [classes.noBorderButton]: curriculumLoading,
    });
    const diaryTitle = cx({
      [classes.text]: true,
      [classes.dangerColor]: diaryState === 'error',
      [classes.successColor]: diaryState === 'success',
    });
    const curriculumTitle = cx({
      [classes.text]: true,
      [classes.successColor]: curriculumState === 'success',
    });

    const content = (
      <GridContainer className={classes.topMargin}>
        <ItemGrid xs={12} sm={6}>
          <FacebookLogin
            appId={config.FACEBOOK_ID}
            fields='name, first_name, last_name, email'
            callback={(response) => this.setProviderInfos(response, 'facebook')}
            scope='public_profile,email'
            render={(renderProps) => (
              <Button
                color='facebook'
                fullWidth
                customClass={`${classes.socialButton} ${classes.facebook}`}
                onClick={renderProps.onClick}>
                <i className={`${classes.socialButtonIcons} ${classes.marginRight10} fab fa-facebook-square`} />{' '}
                Connexion Facebook
              </Button>
            )}
          />
          <GoogleLogin
            clientId={config.GOOGLE_ID}
            onSuccess={(response) => this.setProviderInfos(response, 'google')}
            onFailure={(response) => this.setProviderInfos(response, 'google')}
            render={(renderProps) => (
              <Button
                color='google'
                fullWidth
                customClass={`${classes.socialButton} ${classes.google}`}
                onClick={renderProps.onClick}>
                <i className={`${classes.socialButtonIcons} ${classes.marginRight5} fab fa-google`} /> Connexion Google
              </Button>
            )}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}></ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={emailState === 'success'}
            error={emailState === 'error'}
            labelText={
              <span>
                <Email className={classes.inputLabelIcon} /> Email <small>(obligatoire)</small>
              </span>
            }
            id='email'
            value={email || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'email',
              onChange: (event) => handleOnChange(event.target.value, 'email', 'email'),
            }}
            required
          />
          <CustomPasswordInput
            success={passwordState === 'success'}
            error={passwordState === 'error'}
            labelText={
              <span>
                <LockOutlined className={classes.inputLabelIcon} /> Mot de passe <small>(obligatoire)</small>
              </span>
            }
            id='password'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'password',
              onChange: (event) => handleOnChange(event.target.value, 'password', 'password'),
            }}
            required
          />
          <CustomPasswordInput
            success={confirmPasswordState === 'success'}
            error={confirmPasswordState === 'error'}
            labelText={
              <span>
                <LockOutlined className={classes.inputLabelIcon} /> Confirmez le mot de passe{' '}
                <small>(obligatoire)</small>
              </span>
            }
            id='confirmPassword'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: 'password',
              onChange: (event) => handleOnChange(event.target.value, 'confirmPassword', 'equalTo', 'password'),
            }}
            required
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={firstNameState === 'success'}
            error={firstNameState === 'error'}
            labelText={
              <span>
                Prénom <small>(obligatoire)</small>
              </span>
            }
            id='firstname'
            value={firstName || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'firstName', 'length', 3),
            }}
          />
          <CustomInput
            success={lastNameState === 'success'}
            error={lastNameState === 'error'}
            labelText={
              <span>
                Nom de famille <small>(obligatoire)</small>
              </span>
            }
            id='lastname'
            value={lastName || ''}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'lastName', 'length', 3),
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={phoneState === 'success'}
            error={phoneState === 'error'}
            labelText={
              <span>
                Téléphone portable <small>(obligatoire)</small>
              </span>
            }
            id='phone'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'phone', 'phone'),
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={phoneParentState === 'success'}
            error={phoneParentState === 'error'}
            labelText={
              <span>
                Téléphone parent <small>(obligatoire)</small>
              </span>
            }
            id='phoneParent'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => handleOnChange(event.target.value, 'phoneParent', 'landlinePhone'),
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <CustomInput
            success={true}
            error={false}
            labelText={
              <span>
                Collège <small>(obligatoire)</small>
              </span>
            }
            value={this.state.collegeName}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={6}>
          <WeekPicker
            success={dateState === 'success'}
            error={dateState === 'error'}
            startDate={startDate || null}
            endDate={endDate || null}
            handleChange={(value) => {
              this.setState({ dateSelectected: value }, () => {
                this.checkDateCollege();
              });
              handleOnChange(value, 'date', 'date');
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={hasClasses ? 6 : 12}>
          <SearchBar
            success={addressState === 'success'}
            error={addressState === 'error'}
            labelText={
              <span>
                Adresse <small>(obligatoire)</small>
              </span>
            }
            handleChange={handleChangeAddress}
            handleSelect={handleSelectAddress}
          />
        </ItemGrid>
        {hasClasses && (
          <ItemGrid xs={12} sm={6}>
            <CustomSelectWithId
              success={classState === 'success'}
              error={classState === 'error'}
              labelText='Classe'
              value={this.props.class ? this.props.class : ''}
              data={this.state.classes || []}
              handleChange={(event) => {
                handleOnChange(event.target.value, 'class', 'optionnalSelect');
              }}
            />
          </ItemGrid>
        )}
        <ItemGrid xs={12}>
          <CustomAutoComplete
            success={associationState === 'success'}
            error={associationState === 'error'}
            labelText={
              <small>
                Si tu es suivi par une association pour la recherche de ton stage, tu peux l&apos;indiquer ci-dessous.
              </small>
            }
            value={associationAutoComplete || ''}
            data={this.state.associations}
            handleChange={(event) => {
              handleOnChange(event.target.value, 'association', 'autocomplete');
            }}
            handleSelect={(name, infos) => {
              handleOnSelect(name, infos, 'association');
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={4}>
          <div className={classes.containerUploadAlignLeft}>
            <p className={diaryTitle}>
              Prenez en photo votre carnet de correspondance <small> (obligatoire) </small>
            </p>
          </div>
          {diaryState !== 'success' && (
            <Button customClass={borderButtonCurriculum} color='white' onClick={this.toggleModalDiary}>
              Carnet de correspondance
            </Button>
          )}
          {diaryState === 'success' && (
            <ImageUpload
              key='upload'
              success={diaryState === 'success'}
              error={diaryState === 'error'}
              color='primary'
              handleRemove={() => handleRemoveImage('diary')}
            />
          )}
        </ItemGrid>
        <ItemGrid xs={12} sm={4} className={classes.flexCenter}>
          <div className={classes.containerUpload}>
            <p className={curriculumTitle}>Télécharger votre CV</p>
            <ImageUpload
              success={curriculumState === 'success'}
              color='white'
              customClass={borderButtonCurriculum}
              labelText='curriculum'
              loading={curriculumLoading}
              handleChange={(event) => handleChangeFile(event, 'curriculum')}
              handleRemove={() => handleRemoveFile('curriculum')}
            />

            <p className={classes.helpTextButton}>
              <small>optionnel</small>
            </p>
          </div>
        </ItemGrid>
        <ItemGrid xs={12} sm={4} className={classes.flexCenter}>
          <GridContainer direction='row' justifyContent='center' alignItems='center'>
            <ItemGrid>
              <Checkbox
                id='cgu-checkbox'
                onClick={() => handleOnChange(!checkboxCgu, 'checkboxCgu', 'checked')}
                value='cgu'
                checked={checkboxCgu ? 'checked' : ''}
                className={checkboxCguState === 'error' ? classes.checkboxError : ''}
                required
              />
            </ItemGrid>
            <ItemGrid>
              <label htmlFor='cgu-checkbox' style={{ cursor: 'pointer', userSelect: 'none' }}>
                J&apos;ai lu et j&apos;accepte les{' '}
                <a href='https://www.viensvoirmontaf.fr/mentions-legales/' rel='noopener noreferrer' target='_blank'>
                  conditions générales d&apos;utilisation de ViensVoirMonTaf
                </a>{' '}
                et j&apos;atteste que les informations renseignées sont vraies
              </label>
            </ItemGrid>
          </GridContainer>
        </ItemGrid>
      </GridContainer>
    );

    const footer = (
      <Button color='primary' onClick={this.signUp}>
        Inscription
      </Button>
    );

    const modalDiaryInputs = [
      <img
        key='diary_tutorial_img'
        alt='Tuto de téléchargement de carnet de correspondance'
        className={classes.diaryImg}
        src={tutoStudentDiary}
      />,
      <div key='diary_upload_cancel_buttons' className={classes.diaryButtons}>
        <ImageUpload
          success={diaryState === 'success'}
          error={diaryState === 'error'}
          color='primary'
          labelText="J'ai compris"
          loading={diaryLoading}
          handleChange={async (event) => {
            await handleChangeImage(event, 'diary');
            this.toggleModalDiary();
          }}
        />
        <Button customClass={classes.diaryCancelButton} onClick={this.toggleModalDiary}>
          {' '}
          J&apos;annule{' '}
        </Button>
      </div>,
    ];
    const modalUserExistInputs = [
      <div key='user-exists'>
        <p>
          Apparemment, tu as déjà un compte ViensVoirMonTaf ! S’il te plaît, ne crée qu’un seul compte pour simplifier
          tes démarches auprès des pros
        </p>
        <Button color='primary' onClick={() => this.props.history.push('/auth/connexion')}>
          Je me connecte
        </Button>
        <Button color='warning' onClick={() => this.props.history.push('/auth/mot-de-passe')}>
          J’ai oublié mon mot de passe
        </Button>
      </div>,
    ];

    const modalCheckDateInputs = [
      <div key='check-date'>
        <p>Es-tu sûr de ta date ?</p>
        <p>
          Pour ton collège nous avons les dates suivantes :
          <ul>
            {this.state.collegeSelected.internship_period &&
              typeof this.state.collegeSelected.internship_period[0] === 'object' &&
              this.state.collegeSelected.internship_period.map((period) => {
                if (period.start != null) {
                  return (
                    <li>
                      {format(Date.parse(period.start), 'dd/MM/yyyy')} au {format(Date.parse(period.end), 'dd/MM/yyyy')}{' '}
                    </li>
                  );
                } else {
                  return <div></div>;
                }
              })}
            {this.state.collegeSelected.internship_period &&
              this.state.collegeSelected.internship_period[0] &&
              typeof this.state.collegeSelected.internship_period[0] !== 'object' && (
                <li>
                  {format(Date.parse(this.state.collegeSelected.internship_period[0]), 'dd/MM/yyyy')} au{' '}
                  {format(Date.parse(this.state.collegeSelected.internship_period[1]), 'dd/MM/yyyy')}{' '}
                </li>
              )}
          </ul>
        </p>
      </div>,
    ];

    const modalDiary = this.state.isModalDiaryOpen && (
      <SweetModal
        title='Télécharger une photo de carnet qui convient'
        isOpen={this.state.isModalDiaryOpen}
        inputs={modalDiaryInputs}
        noSubmit
        noCancel
        toggleModal={this.toggleModalDiary}
        maxWidth='lg'
      />
    );
    const modalUserExist = this.state.isModalOpenUserExistOpen && (
      <SweetModal
        title='Utilisateur déjà existant'
        isOpen={this.state.isModalOpenUserExistOpen}
        inputs={modalUserExistInputs}
        submit={this.toggleModalUserExist}
        toggleModal={this.toggleModalUserExist}
        noCancel
        noSubmit
      />
    );

    const modalCheckDate = this.state.isModalCheckDateOpen && (
      <SweetModal
        title='Dates non conforme'
        isOpen={this.state.isModalCheckDateOpen}
        inputs={modalCheckDateInputs}
        submit={this.toggleModalCheckDate}
        toggleModal={this.toggleModalCheckDate}
        noCancel
      />
    );

    const snackbarContainer = snackbar && snackbar.isSnackbar && (
      <Snackbar
        key='snackbar'
        place='bc'
        color={snackbar.status}
        icon={AddAlert}
        message={snackbar.message}
        open={true}
        closeNotification={closeSnackbar}
        close
      />
    );

    return (
      <ErrorBoundaries>
        <div className={classes.content}>
          {snackbarContainer}
          {modalDiary}
          {modalUserExist}
          {modalCheckDate}
          <GridContainer justifyContent='center'>
            <ItemGrid xs={12} sm={10}>
              <form>
                <IconCard
                  icon={Face}
                  iconColor='red'
                  title='Inscription élève'
                  content={content}
                  footer={footer}
                  footerAlign='right'
                  footerBorder
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </ErrorBoundaries>
    );
  }
}

StudentRegisterRep.propTypes = {
  classes: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  clearInput: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleChangeAddress: PropTypes.func.isRequired,
  handleSelectAddress: PropTypes.func.isRequired,
  handleChangeImage: PropTypes.func.isRequired,
  handleRemoveImage: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  firstNameState: PropTypes.string,
  lastName: PropTypes.string,
  lastNameState: PropTypes.string,
  phone: PropTypes.string,
  phoneState: PropTypes.string,
  address: PropTypes.string,
  addressState: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  department: PropTypes.string,
  college: PropTypes.object,
  collegeAutoComplete: PropTypes.string,
  collegeState: PropTypes.string,
  association: PropTypes.object,
  associationAutoComplete: PropTypes.string,
  associationState: PropTypes.string,
  picture: PropTypes.string,
  pictureState: PropTypes.string,
  pictureLoading: PropTypes.bool,
  diaryLoading: PropTypes.bool,
  diaryState: PropTypes.string,
  curriculumLoading: PropTypes.bool,
  curriculumState: PropTypes.string,
};

const WrappedComponent = FormHOC(StudentRegisterRep);

export default withStyles(detailsPageStyle)((props) => (
  <Context.Consumer>{(context) => <WrappedComponent {...props} context={context} />}</Context.Consumer>
));
